export const handleRefresh = () => {
    window.location.reload();
};

